import React from 'react';
import TemplateBuilder from './TemplateBuilder';

function App() {
  return <TemplateBuilder />;
}

export default App;
